import * as React from "react";
import '../App.css';
import { useNavigate } from "react-router-dom";
import * as data from '../utils/data';
import { countries, countryOptions } from "../utils/constants/countryOptions";
import { queryTypesByCountry } from "../utils/constants/constants";
import { useAuth } from "../context/AuthContext";
import ReadPrefs from "./datawriter/readPrefs";
import { useFetch } from "./hooks/useFetch";
import { useEffect } from "react";

function IndexPage() {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = React.useState("US");
  const [selectedJurisdictionIndex, setSelectedJurisdictionIndex] = React.useState(0);
  const [queryType, setQueryType] = React.useState("");
  const {roles, email, token} = useAuth();
  const reader = useFetch(null);
  const fullUrl = window.location.href;
  console.log("Is Test ", data.isTestEnv)
  data.setErrorReceived([]);
  data.clearAkaCache();
  data.clearMinimalCache();
  data.clearHistoryCache();
  // Determine role from session (matches constants.js)
  const usrRoles = JSON.parse(sessionStorage.getItem("roles")) ?? [];
  const ctx = {
    role:
      usrRoles.includes("cdlisAdmin") ? "admin" :
      usrRoles.includes("minimalDrivReq") ? "minimal" :
      "cdlisUsr",
    caFcwdOnly: 
      usrRoles.includes("cdlisFcwdOnly") ? true : false
  };
  const config = queryTypesByCountry[selectedCountry] ?? queryTypesByCountry.OTHER;
  const queryTypes = typeof config === "function" ? config(ctx) : config;

  // Set default selected queryType
  useEffect(() => {
    if (!queryTypes.includes(queryType)) {
      setQueryType(queryTypes[0] || "");
    }
  }, [queryTypes]);

  // 1. Define the test endpoints
  const testEndpoints = [
    { code: "Z6", label: "(Z6)TESTING" },
    { code: "P6", label: "(P6)TESTING" },
    { code: "P3", label: "(P3)TESTING" }
  ];

  // 2. Build the dynamic jurisdiction list based on country and environment
  const currentJurisdictionList = React.useMemo(() => {
    const baseList = countryOptions[selectedCountry] || [];
    if (selectedCountry === "US" && data.isTestEnv) {
      return [...testEndpoints, ...baseList];
    }
    return baseList;
  }, [selectedCountry, data.isTestEnv]);

  const handleSubmit = (event) => {
    event.preventDefault();
    [
      'DriverLastNameTrunCode', 'DriverLastNameTranCode',
      'DriverFirstNameTrunCode', 'DriverFirstNameTranCode',
      'DriverMiddleNameTrunCode', 'DriverMiddleNameTranCode',
      'AkaLastNameTrunCode', 'AkaLastNameTranCode',
      'AkaFirstNameTrunCode', 'AkaFirstNameTranCode',
      'AkaMiddleNameTrunCode', 'AkaMiddleNameTranCode'
    ].forEach(key => localStorage.removeItem(key));
    const jurisdictionList = currentJurisdictionList;
    const selectedJurisdiction = jurisdictionList[selectedJurisdictionIndex];

    data.clearRequest();
    data.setUserId(email || "undefined");
    data.setCountry(selectedCountry);
    data.setJurisdiction(selectedJurisdiction);
    data.setQueryType(queryType);

    console.log("Data being sent", data.selectionRequest)
    // Normalize to route path
    const routeMap = {
      "Driver Status": "statussearch",
      "Driver History": "historysearch",
      "Driver AKA": "akasearch",
      "Driver Inquiry": "inquirysearch",
      "Driver Minimal": "minimalsearch",
      "Vehicle/Carrier": "vehiclesearch",
      "FCWD Driver Inquiry": "inquirysearch",
    };

    const path = routeMap[queryType] || "statussearch";
    data.setQueryType(path);
    navigate(`/${path}`);
  };

  //alert(JSON.stringify(countries))

  if(roles !== null){
    if(!roles.includes("minimalDrivReq")){
      queryTypes.splice(3);
    }

    if(!roles.includes("searchCn")){
      //countries.splice(  {"code": "CA", "label": "Canada"})
      if(countries[1].code === "CA")
      countries.splice(1,1);
    }

    if(!roles.includes("searchMx")){

      if(countries[1].code === "MX"){
        countries.splice(1,1);
      }
      if(countries[2].code === "MX"){
         countries.splice(2,2);
      }
    }
  }

  return (
    <div className="Index">
      <div id="table" style={{ width: "50%" }}>
        <div id="banner-search">
          <h4>Select Query Filter</h4>
          <div ref={reader}><ReadPrefs email={email} 
          setSelectedCountry={setSelectedCountry}
          setQueryType={setQueryType}
          setSelectedJurisdictionIndex={setSelectedJurisdictionIndex}
          token={token}
          /></div>
        </div>
        <form id="Index-form" onSubmit={handleSubmit}>
          <label>
            <b>Country:</b>
            <br />
            <select
              className="form-select form-select-lg mb-3"
              value={selectedCountry}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setSelectedJurisdictionIndex(0);
              }}
            >
              {countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.label}
                </option>
              ))}
            </select>
          </label>

          <br />
          <label>
            <b>Query Type:</b>
            <br />
            <select
              className="form-select form-select-lg mb-3"
              name="selectedType"
              value={queryType}
              onChange={(e) => setQueryType(e.target.value)}
            >
              {queryTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </label>

          <br />
          <tr>
          <label>
            <b>Jurisdiction:</b>
            <br />
            <select
              className="form-select form-select-lg mb-3"
              name="selectedJurisdiction"
              value={selectedJurisdictionIndex}
              onChange={(e) => setSelectedJurisdictionIndex(parseInt(e.target.value))}
            >
              {currentJurisdictionList.map((j, idx) => (
                <option key={j.code} value={idx}>
                  {j.label}
                </option>
              ))}
            </select>
          </label>
          </tr>
          <button type="submit" className="btn btn-primary" id="button">
            Next
          </button>
        </form>
      </div>
    </div>
  );
}

export default IndexPage;
